export const LAYOUTS = {
  horizontal: { label: "横向排列", columns: (count) => count },
  vertical: { label: "纵向排列", columns: () => 1 },
  grid: { label: "2 × 2", columns: () => 2 },
};

export function availableLayouts(count) {
  return count === 2 ? ["horizontal", "vertical"] : ["grid", "horizontal", "vertical"];
}

export function recommendedLayout(images) {
  const layouts = availableLayouts(images.length);
  let best = layouts[0];
  let bestScore = Number.POSITIVE_INFINITY;

  for (const layout of layouts) {
    const result = calculateLayout(images, layout, 0);
    const ratio = result.width / result.height;
    const score = Math.abs(Math.log(ratio));
    if (score < bestScore) {
      best = layout;
      bestScore = score;
    }
  }
  return best;
}

export function calculateLayout(images, layout, gap = 0) {
  if (![2, 4].includes(images.length)) {
    throw new Error("Only 2 or 4 images are supported.");
  }
  if (!availableLayouts(images.length).includes(layout)) {
    throw new Error("The selected layout is not available for this image count.");
  }
  if (!Number.isInteger(gap) || gap < 0 || gap > 512) {
    throw new Error("Gap must be an integer between 0 and 512.");
  }

  const columns = LAYOUTS[layout].columns(images.length);
  const rows = Math.ceil(images.length / columns);
  const columnWidths = Array(columns).fill(0);
  const rowHeights = Array(rows).fill(0);

  images.forEach((image, index) => {
    const column = index % columns;
    const row = Math.floor(index / columns);
    columnWidths[column] = Math.max(columnWidths[column], image.width);
    rowHeights[row] = Math.max(rowHeights[row], image.height);
  });

  const columnOffsets = offsets(columnWidths, gap);
  const rowOffsets = offsets(rowHeights, gap);
  const placements = images.map((image, index) => {
    const column = index % columns;
    const row = Math.floor(index / columns);
    return {
      x: columnOffsets[column] + Math.floor((columnWidths[column] - image.width) / 2),
      y: rowOffsets[row] + Math.floor((rowHeights[row] - image.height) / 2),
      width: image.width,
      height: image.height,
      row,
      column,
    };
  });

  return {
    width: columnWidths.reduce(sum, 0) + gap * (columns - 1),
    height: rowHeights.reduce(sum, 0) + gap * (rows - 1),
    columns,
    rows,
    placements,
  };
}

function offsets(sizes, gap) {
  const result = [];
  let cursor = 0;
  for (const size of sizes) {
    result.push(cursor);
    cursor += size + gap;
  }
  return result;
}

function sum(total, value) {
  return total + value;
}

export function scaledCrop(placement, sourceWidth, sourceHeight, manifestWidth, manifestHeight) {
  const scaleX = sourceWidth / manifestWidth;
  const scaleY = sourceHeight / manifestHeight;
  return {
    x: Math.round(placement.x * scaleX),
    y: Math.round(placement.y * scaleY),
    width: Math.round(placement.width * scaleX),
    height: Math.round(placement.height * scaleY),
  };
}
